
import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { LoginService } from './login/login.service';
import { AppStateService } from './shared/app-state.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private loginService: LoginService, private appStateService: AppStateService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {
    const token = this.loginService.getToken();

    if (token) {
      // console.log('User logged in, add token with Interceptor');
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
        url: `${req.url}`
      });
      console.log(authReq);
      return next.handle(authReq);
    }

    return next.handle(req.clone({ url: `${req.url}` }));
  }

}
